import { useState } from 'react';
import { supabase } from '../lib/supabase';

const DEFAULT_CATS=['Food','Liquor','Beer','Wine'];

const TIMEZONES=[
  {v:'America/New_York',l:'Eastern (ET)'},
  {v:'America/Chicago',l:'Central (CT)'},
  {v:'America/Denver',l:'Mountain (MT)'},
  {v:'America/Los_Angeles',l:'Pacific (PT)'},
  {v:'America/Anchorage',l:'Alaska (AKT)'},
  {v:'Pacific/Honolulu',l:'Hawaii (HT)'},
];

export default function Onboarding({t,mn,si,sb,orgId,uid,save,setOnboardingComplete,settings,setSettings}){
const[step,setStep]=useState(1);
const[bizName,setBizName]=useState(settings?.bizName||'');
const[tz,setTz]=useState('America/New_York');
const[cats,setCats]=useState(()=>{const m={};DEFAULT_CATS.forEach(c=>m[c]=true);return m;});
const[newCat,setNewCat]=useState('');
const[fxRows,setFxRows]=useState([
  {n:'Rent',amt:'',per:'monthly'},
  {n:'Manager Salary',amt:'',per:'monthly'},
  {n:'Insurance',amt:'',per:'monthly'},
]);
const[saving,setSaving]=useState(false);

const stepLabel=['Restaurant Setup','Sales Categories','Fixed Costs'][step-1];

async function finish(skipFx){
  setSaving(true);
  const activeCats=Object.entries(cats).filter(([,v])=>v).map(([k])=>k);
  setSettings(p=>({...p,bizName,salesCategories:activeCats}));
  await save.saveSettings(orgId,uid,{bizName,salesCategories:activeCats});
  await supabase.from('organizations').update({name:bizName||'My Restaurant',timezone:tz,onboarding_complete:true}).eq('id',orgId);
  if(!skipFx){
    const valid=fxRows.filter(r=>r.n.trim()&&parseFloat(r.amt)>0);
    for(const r of valid){
      const id=crypto.randomUUID();
      save.upsertFixedCost(orgId,uid,{id,n:r.n.trim(),amt:parseFloat(r.amt),per:r.per});
    }
  }
  setOnboardingComplete(true);
  setSaving(false);
}

const card={background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,padding:24,width:'100%',maxWidth:520};
const label={fontSize:9,color:t.td,textTransform:'uppercase',letterSpacing:1,marginBottom:4};
const btn=(primary)=>({...sb,background:primary?t.ac:t.sf,color:primary?'#fff':t.tm,border:primary?'none':`1px solid ${t.bd}`,padding:'10px 24px',fontSize:13,fontWeight:600,cursor:'pointer'});

return(
<div style={{minHeight:'100vh',background:t.bg,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:24,fontFamily:"'DM Sans','Helvetica Neue',sans-serif",color:t.tx}}>
<link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap" rel="stylesheet"/>

<div style={{fontFamily:mn,fontSize:24,fontWeight:700,letterSpacing:4,color:t.ac,marginBottom:4}}>MISE</div>
<div style={{fontSize:10,color:t.td,letterSpacing:2,marginBottom:32}}>EN PLACE</div>

{/* Step indicator */}
<div style={{display:'flex',gap:8,marginBottom:24,alignItems:'center'}}>
{[1,2,3].map(s=><div key={s} style={{display:'flex',alignItems:'center',gap:8}}>
<div style={{width:28,height:28,borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:600,background:s<=step?t.ac:'transparent',color:s<=step?'#fff':t.td,border:s<=step?'none':`1px solid ${t.bd}`}}>{s}</div>
{s<3&&<div style={{width:32,height:1,background:s<step?t.ac:t.bd}}/>}
</div>)}
</div>
<div style={{fontSize:11,color:t.td,marginBottom:20}}>Step {step} of 3 — {stepLabel}</div>

{step===1&&<div style={card}>
<div style={{fontSize:16,fontWeight:600,marginBottom:16}}>Restaurant Setup</div>
<div style={{marginBottom:16}}>
<div style={label}>Restaurant Name</div>
<input value={bizName} onChange={e=>setBizName(e.target.value)} placeholder="e.g. The Stadium" style={{...si,width:'100%',fontSize:14,padding:'10px 12px'}}/>
</div>
<div style={{marginBottom:16}}>
<div style={label}>Timezone</div>
<select value={tz} onChange={e=>setTz(e.target.value)} style={{...si,width:'100%',fontSize:13,padding:'10px 12px'}}>
{TIMEZONES.map(z=><option key={z.v} value={z.v}>{z.l}</option>)}
</select>
</div>
<div style={{display:'flex',justifyContent:'flex-end',marginTop:20}}>
<button onClick={()=>setStep(2)} disabled={!bizName.trim()} style={{...btn(true),opacity:bizName.trim()?1:0.5}}>Next</button>
</div>
</div>}

{step===2&&<div style={card}>
<div style={{fontSize:16,fontWeight:600,marginBottom:4}}>Sales Categories</div>
<div style={{fontSize:12,color:t.td,marginBottom:16}}>Check the POS categories you use. Uncheck any you don't need.</div>
<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
{Object.keys(cats).map(c=><label key={c} style={{display:'flex',alignItems:'center',gap:8,padding:'8px 10px',borderRadius:8,border:`1px solid ${t.bd}`,background:cats[c]?t.sf:'transparent',cursor:'pointer',fontSize:13}}>
<input type="checkbox" checked={cats[c]||false} onChange={()=>setCats(p=>({...p,[c]:!p[c]}))}/>
{c}
</label>)}
</div>
<div style={{display:'flex',gap:8,marginTop:12}}>
<input value={newCat} onChange={e=>setNewCat(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'&&newCat.trim()){setCats(p=>({...p,[newCat.trim()]:true}));setNewCat('');}}} placeholder="e.g. Non-Alcoholic Beverages" style={{...si,flex:1,fontSize:12}}/>
<button onClick={()=>{if(newCat.trim()){setCats(p=>({...p,[newCat.trim()]:true}));setNewCat('');}}} style={{...sb,background:t.sf,color:t.tm,border:`1px solid ${t.bd}`,fontSize:11,padding:'6px 12px'}}>+ Add</button>
</div>
<div style={{display:'flex',justifyContent:'space-between',marginTop:20}}>
<button onClick={()=>setStep(1)} style={btn(false)}>Back</button>
<button onClick={()=>setStep(3)} style={btn(true)}>Next</button>
</div>
</div>}

{step===3&&<div style={{...card,maxWidth:560}}>
<div style={{fontSize:16,fontWeight:600,marginBottom:4}}>Fixed Costs</div>
<div style={{fontSize:12,color:t.td,marginBottom:16}}>Add your monthly fixed costs. These power your P&L from day one.</div>
<div style={{display:'grid',gridTemplateColumns:'1fr 100px 110px 32px',gap:6,alignItems:'center',marginBottom:4}}>
<div style={label}>Name</div><div style={label}>Amount ($)</div><div style={label}>Frequency</div><div/>
</div>
{fxRows.map((r,i)=><div key={i} style={{display:'grid',gridTemplateColumns:'1fr 100px 110px 32px',gap:6,alignItems:'center',marginBottom:4}}>
<input value={r.n} onChange={e=>{const v=e.target.value;setFxRows(p=>p.map((x,j)=>j===i?{...x,n:v}:x));}} placeholder="e.g. Rent" style={{...si,fontSize:12}}/>
<input type="number" value={r.amt} onChange={e=>{const v=e.target.value;setFxRows(p=>p.map((x,j)=>j===i?{...x,amt:v}:x));}} placeholder="0.00" style={{...si,fontSize:12,fontFamily:mn,textAlign:'center'}}/>
<select value={r.per} onChange={e=>{const v=e.target.value;setFxRows(p=>p.map((x,j)=>j===i?{...x,per:v}:x));}} style={{...si,fontSize:11}}>
<option value="monthly">Monthly</option><option value="weekly">Weekly</option><option value="yearly">Yearly</option>
</select>
<button onClick={()=>setFxRows(p=>p.filter((_,j)=>j!==i))} style={{...sb,background:'transparent',color:t.td,padding:4,fontSize:11,border:'none'}}>✕</button>
</div>)}
<button onClick={()=>setFxRows(p=>[...p,{n:'',amt:'',per:'monthly'}])} style={{...sb,background:'transparent',color:t.tm,border:`1px solid ${t.bd}`,fontSize:11,marginTop:4,padding:'6px 12px'}}>+ Add Row</button>
<div style={{display:'flex',justifyContent:'space-between',marginTop:20}}>
<button onClick={()=>setStep(2)} style={btn(false)}>Back</button>
<div style={{display:'flex',gap:8}}>
<button onClick={()=>finish(true)} disabled={saving} style={btn(false)}>Skip for now</button>
<button onClick={()=>finish(false)} disabled={saving} style={btn(true)}>{saving?'Saving...':'Finish Setup'}</button>
</div>
</div>
</div>}

</div>);
}
